module.exports = __webpack_public_path__ + "img/hot_game.a01d18dc.png";